<template>
    <mu-flex justify-content="end" align-items="center" class="header-user">
        <div class="name">
            Olá, <router-link :to="{ name: 'app.profile' }"><strong>{{ firstName }}</strong></router-link>
        </div>
        <a href="javascript:;" @click="logout()">Sair</a>
        <font-awesome-icon icon="sign-out-alt" @click="logout()" />
    </mu-flex>
</template>

<script>
    export default {
        name: 'notifications',

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pega os 15 primeiros caracteres do primeiro nome do usuário
             */
            firstName () {
                if (this.$store.state.user && this.$store.state.user.firstName) {
                    return this.$store.state.user.firstName.substring(0, 15)
                }
                return ''
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a listagem de fornecedores com sua consumação
             */
            async logout () {
                this.$eventHub.$emit('loading', true, 'Aguarde, deslogando da plataforma.')

                this.$store.dispatch('logout').then((response) => {
                    this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
                }).catch((response) => {
                    this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
                })

                this.$eventHub.$emit('loading', false)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .header-user

        padding-right 10px

        .name
            padding-right 9px
            margin-right 10px
            border-right 1px solid rgba(255, 255, 255, 0.4)

        svg
            margin 0 10px
            cursor pointer

        a
            color #fff

</style>
